import { Button } from '@/components/ui/button.tsx';
import { Plus, Workflow, Upload, Tag } from 'lucide-react';

interface FunnelHeaderProps {
    onCreateClick: () => void;
    onImportClick?: () => void;
    onCategoriesClick?: () => void;
}

export default function FunnelHeader({ onCreateClick, onImportClick, onCategoriesClick }: FunnelHeaderProps) {
    return (
        <div className="relative overflow-hidden rounded-2xl bg-gradient-to-r from-[#0f172a] via-[#1e293b] to-[#0f172a] p-8 shadow-xl">
            {/* Decorative elements */}
            <div className="absolute top-0 right-0 w-64 h-64 bg-[#7dd3fc]/10 rounded-full blur-3xl -translate-y-1/2 translate-x-1/4" />
            <div className="absolute bottom-0 left-0 w-48 h-48 bg-[#38bdf8]/10 rounded-full blur-3xl translate-y-1/2 -translate-x-1/4" />

            <div className="relative flex items-center justify-between">
                <div className="flex items-center gap-4">
                    <div className="flex items-center justify-center w-12 h-12 rounded-xl bg-white/10 backdrop-blur-sm border border-white/10">
                        <Workflow className="w-6 h-6 text-[#7dd3fc]" />
                    </div>
                    <div>
                        <h1 className="text-2xl font-bold text-white">Funis</h1>
                        <p className="mt-1 text-sm text-slate-300">
                            Gerencie seus funis de automação
                        </p>
                    </div>
                </div>
                <div className="flex items-center gap-2">
                    {onCategoriesClick && (
                        <Button
                            onClick={onCategoriesClick}
                            className="bg-white/5 hover:bg-white/15 text-white/80 hover:text-white font-medium px-4 py-2.5 rounded-xl border border-white/10 backdrop-blur-sm transition-all duration-300"
                        >
                            <Tag className="w-4 h-4 mr-2" />
                            Categorias
                        </Button>
                    )}
                    {onImportClick && (
                        <Button
                            onClick={onImportClick}
                            className="bg-white/5 hover:bg-white/15 text-white/80 hover:text-white font-medium px-4 py-2.5 rounded-xl border border-white/10 backdrop-blur-sm transition-all duration-300"
                        >
                            <Upload className="w-4 h-4 mr-2" />
                            Importar JSON
                        </Button>
                    )}
                    <Button
                        onClick={onCreateClick}
                        className="bg-white/10 hover:bg-white/20 text-white font-medium px-6 py-2.5 rounded-xl border border-white/10 backdrop-blur-sm transition-all duration-300 hover:shadow-lg hover:shadow-[#7dd3fc]/10"
                    >
                        <Plus className="w-5 h-5 mr-2" />
                        Novo Funil
                    </Button>
                </div>
            </div>
        </div>
    );
}